import { useCallback, useEffect, useState } from 'react';
import { sessionsApi } from '../../../../api/sessionsApi';
import { normalizeSession } from '../utils/normalizeSession';

/** The session shown on the detail page; failures are reported through `notify` and leave it null. */
export function useSessionDetail(sessionId, notify) {
  const [session, setSession] = useState(null);

  const reloadSession = useCallback(async () => {
    try {
      const res = await sessionsApi.get(sessionId);
      if (!res || Object.keys(res).length === 0) {
        notify({ type: 'error', title: 'Session unavailable', message: 'The backend returned an empty session response.' });
        setSession(null);
      } else {
        setSession(normalizeSession(res));
      }
    } catch (e) {
      notify({ type: 'error', title: 'Failed to load session', message: e.message });
      setSession(null);
    }
  }, [sessionId, notify]);

  useEffect(() => {
    reloadSession();
  }, [reloadSession]);

  return { session, setSession, reloadSession };
}
